import { useState } from 'react';
import SearchBtn from '../../component/common/button/SearchBtn';
import NewDataGrid from '../../component/common/dataGrid/NewDataGrid';
import Main from '../../component/Main';

const ExcelDownLog = () => {

	const [searchParams, setSearchParams] = useState({
		searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
		searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
		searchGubun: '',
		searchCnt: '',
	});

	const searchParamsAdditional = {
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		const newParams = {
			...searchParams,
			[name]: value
		};
		setSearchParams(newParams);
	};

	const dataHead = ['사용자 ID', '파일명', '다운로드 사유', '다운로드 시점', '기타 사유 설명'];
	const dataColumn = ['EXCEL_USERID', 'EXCEL_FILENAME', 'EXCEL_REASON', 'EXCEL_DOWNDTM', 'EXCEL_REASON_ETC'];
	const apiCall = '/commonapi/exceldown/selectXLSXDOWNREASONList.do';
	const apiCntCall = '/commonapi/exceldown/selectXLSXDOWNREASONListCnt.do';
	const excelFileName = '엑셀다운로드 로그';
	const excelHead = [];

	const propsInfo = {
		dataHead: dataHead,
		dataColumn: dataColumn,
		apiCall: apiCall,
		apiCntCall: apiCntCall,
		excelFileName: excelFileName,
		excelHead: excelHead
	}

	const [state, setState] = useState({
		dataList: [],
		isSearched: false,
		isLoading: false
	})

	const [pageInfo, setPageInfo] = useState({
		paginationTF: true,
		currentPage: 1,
		itemsPerPage: 50,
		totalItems: 0
	});

	return (
        <Main>
			<div className="com-search">
				<table>
					<colgroup>
						<col width="9%" />
						<col width="32%" />
						<col width="11%" />
						<col width="20%" />
						<col width="9%" />
						<col width="20%" />
					</colgroup>
					<tbody>
						<tr>
							<th>검색 기간</th>
							<td>
								<input
								type="date"
								name="searchFromdate"
								value={searchParams.searchFromdate}
								onChange={handleInputChange}
								/>
								&nbsp;~&nbsp;
								<input
								type="date"
								name="searchTodate"
								value={searchParams.searchTodate}
								onChange={handleInputChange}
								min={searchParams.searchFromdate}
								/>
							</td>
							<th>다운로드 사유</th>
							<td>
								<select
								id="searchCnt"
								name="searchCnt"
								className='w-full'
								value={searchParams.searchCnt}
								onChange={handleInputChange}
								>
								<option value="">전체</option>
								<option value="1">기관 제출용</option>
								<option value="2">내부 보관용</option>
								<option value="3">통계 분석 및 관리용</option>
								<option value="4">기타</option>
								</select>
							</td>
							<th>사용자 ID</th>
							<td>
								<input
								type="text"
								id="searchGubun"
								className='input_style'
								name="searchGubun"
								value={searchParams.searchGubun}
								onChange={handleInputChange}
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<SearchBtn
				propsInfo={propsInfo}
				state={state}
				setState={setState}
				searchParams={searchParams}
				searchParamsAdditional={searchParamsAdditional}
				pageInfo={pageInfo}
				setPageInfo={setPageInfo}
			/>
			<NewDataGrid
				propsInfo={propsInfo}
				state={state}
				pageInfo={pageInfo}
				setPageInfo={setPageInfo}
			/>
		</Main>
	)
}

export default ExcelDownLog;